import { render, staticRenderFns } from "./GitlabOpenModal.vue?vue&type=template&id=373bef72&"
import script from "./GitlabOpenModal.vue?vue&type=script&lang=js&"
export * from "./GitlabOpenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GitlabOpenModal.vue
// module id = 1064
// module chunks = 0